import { Box, Text } from "@chakra-ui/react";

import { Errors, getErrorArray } from "../utils/get-errors";

import { RanaAlert, RanaAlertProps } from "./rana-alert";

export interface RanaErrorsProps extends RanaAlertProps {
  errors: Errors | string | null | undefined;
}

export function RanaErrors({ errors, ...rest }: RanaErrorsProps) {
  if (!errors || !Object.keys(errors).length) return null;

  return (
    // FUTURE: double check this gap. It might be way too big
    <RanaAlert {...rest} status="error" gap={11}>
      <Box>
        {typeof errors === "string"
          ? errors
          : getErrorArray(errors).map((error, index) => <Text key={index}>{error}</Text>)}
      </Box>
    </RanaAlert>
  );
}
